import { useEffect } from 'react';

interface SEOMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  schemaData?: Record<string, unknown>;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
  schemaData,
}: SEOMetaProps) {
  useEffect(() => {
    document.title = title;
    updateMeta('description', description);
    if (keywords) updateMeta('keywords', keywords);
    if (canonicalUrl) {
      updateLink('canonical', canonicalUrl);
    }

    updateMeta('og:title', ogTitle || title);
    updateMeta('og:description', ogDescription || description);
    updateMeta('og:type', ogType);

    const schemaScriptId = 'schema-jsonld';
    const existingSchema = document.getElementById(schemaScriptId);
    if (existingSchema) existingSchema.remove();

    if (schemaData) {
      const script = document.createElement('script');
      script.id = schemaScriptId;
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schemaData);
      document.head.appendChild(script);
    }
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType, schemaData]);

  return null;
}

function updateMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    if (name.startsWith('og:') || name.startsWith('twitter:')) {
      el.setAttribute('property', name);
    } else {
      el.setAttribute('name', name);
    }
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function updateLink(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}